import { commons, forecasts, measurements } from '../../enums/MetricIds';
const preferredOrder = ['RR', 'T', 'U', 'FF', 'T_DRY', 'T_WET'];
const otherMetrics = [...commons, ...measurements, ...forecasts].filter((m) => !preferredOrder.includes(m));
export const preferredMetricsOrder = ['RR', 'T', 'U', 'FF', 'T_DRY', 'T_WET', ...otherMetrics];
export const defaultHeaderValues = [
    { id: 'latest', isMainValue: true },
    { id: 'minToday' },
    { id: 'maxToday' }
];
/** Metrics that we always want to show on the daily weather summary */
export const dailyWeatherAlwaysAvailableMetrics = ['RR', 'T', 'U'];
/**
 * Metrics that can be part of a plot/device available measures
 * BUT that we may want to hide, or handle on their own
 */
export const dailyWeatherExcludedMetrics = [
    'T_CAL',
    'T_CAPA',
    'T_WET',
    'T_DRY',
    'FXY',
    'DD',
    'DXY',
    'HPOT',
    'U_CAPA',
    'LW_D',
    'LW_V',
    'SSI_HOURS',
    'SSI_MAX',
    'SSI_MIN',
    'PPFD_MAX',
    'PPFD_MIN'
];
/** Metrics for which we want to display a chart on the daily weather */
export const dailyWeatherCharts = ['RR'];
/**
 * Metrics that can be part of a plot/device available measures
 * BUT that we never want to display a chart for on summaries
 */
export const metricsWithoutChart = [
    // Displayed with T_WET
    'T_DRY',
    // Displayed with FF
    'FXY',
    'DD',
    'DXY',
    // Never displayed
    'SSI_HOURS',
    'SSI_MAX',
    'SSI_MIN',
    'PPFD_MAX',
    'PPFD_MIN'
];
